import { Box, Paper, Typography } from "@mui/material"
import TaskListController from "./TaskListController"

const GeneralTaskController = ()=>{
return <Paper component={Box} p={3} mt={4} mb={4}>
    <Typography variant="h3"  mb={4}>General Tasks</Typography>
    <TaskListController notMe={true} general={true} />
</Paper>
}
export default GeneralTaskController